<template lang="pug">
span
  v-snackbar(:value="getFileError" color="error")
    span There is an error with your report, try again later.
  v-dialog(v-model="value" width="575" persistent lazy)
    v-card
      title-bar.py-4(dark :loading="isLoading") 
        | Download ad portal reports
      v-card-text
        v-layout.ma-3(column align-center wrap)
          v-icon(size="75" dark color="primary") $vuetify.icons.file-excel
          span.text-xs-center.my-4.px-5 Your ad portal report is created daily, 
            | each file is retroactive to the day you started using the ad portal.
          v-btn.mt-2(
            color="primary"
            :disabled="!isFileAvailableToDownload"
            :href="adReportPath"
          ) Download
      v-card-actions.pa-3
        v-layout(row justify-end)
          v-btn.primary--text(flat @click="$emit('close')") Close
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';

const { 
  mapState: mapFilesState, 
  mapGetters: mapFilesGetters, 
  mapActions: mapFilesActions,
  mapMutations: mapFilesMutations,
} = createNamespacedHelpers('files');

export default {
  name: 'DownloadAdReportModal',
  components: { TitleBar },
  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isLoading: false,
      adReportFileFolderId: 0,
      adReportPath: '',
    };
  },
  watch: {
    async value(val) {
      if (val) {
        this.isLoading = true;
        await this.getAdReportFileFolders();
        if (!this.fileFolderError) await this.getDailyAdReport();
        this.isLoading = false;
      }
    },
  },
  computed: {
    ...mapFilesState(['files', 'fileFolders', 'fileError', 'fileFolderError']),
    ...mapFilesGetters(['getTodayEvocalizeAdReport']),
    isFileAvailableToDownload() {
      return !this.fileError
        && !this.fileFolderError
        && !this.isLoading
        && this.getTodayEvocalizeAdReport;
    },
    getFileError: {
      get() {
        return this.fileError || this.fileFolderError;
      },
      set(value) {
        this.setFileError(value);
        this.setFileFolderError(value);
      }
    }
  },
  methods: {
    ...mapFilesActions([
      'findFileFolders',
      'findFiles',
      'createAdReport',
      'createFileFolder',
    ]),
    ...mapFilesMutations(['setFileError', 'setFileFolderError']),
    async getAdReportFileFolders() {
      await this.findFileFolders({ folder_name: 'Ad-Reports' });
      if (!this.fileFolders.length) {
        await this.createFileFolder('Ad-Reports');
      }
      if (!this.fileFolderError) {
        this.adReportFileFolderId = this.fileFolders[0].id;
      }
    },
    async getDailyAdReport() {
      await this.findFiles({
        file_folder_id: this.adReportFileFolderId
      });
      if (!this.files.length || !this.getTodayEvocalizeAdReport) {
        await this.createAdReport(this.adReportFileFolderId);
      }
      if (!this.fileError) {
        const file = this.getTodayEvocalizeAdReport;
        this.adReportPath = file.path;
      }
    },
  },
};
</script>
